import { useMeters } from "@features/mx/routeManagement/hooks";
import { GenericTable } from "@shared/components/GenericTable";
import { PageHeader } from "@shared/components/PageHeader";
import { TableColumn } from "@shared/types/table";
import { Card } from "@shared/ui/card";
import { MODAL_PAGE_SIZE } from "@shared/utils/constants";
import { BarChart3, Wrench } from "lucide-react";
import { useState } from "react";


interface ReadingRecord {
  id:number;
  date: string;
  month: string;
  readType: string;
  reading: number;
  status: 'valid' | 'invalid';
  reader: string;
  validator: string;
}

export const MetersTable = ({ selectedPremises }: { selectedPremises: string[] }) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  const { data: metersList, isLoading } = useMeters(
    selectedPremises,
    currentPage,
    MODAL_PAGE_SIZE
  );
  const metersData = metersList?.results || [];
    const totalCount = metersList?.count || 0; 


  const columns: TableColumn<ReadingRecord>[] = [
    {
      key: "meterNumber",
      header: "Meter Number",
      headerTooltip:"Unique identifier for the meter device. Used for tracking readings and maintenance history."
    },
    {
      key: "deviceNo",
      header: "Device Number",
      headerTooltip:"Hardware serial number. Used for device-specific troubleshooting and warranty tracking."
    },
    {
      key: "consumerName",
      header: "Consumer Name",
     headerTooltip:"Account holder or service recipient. Links meter readings to billing records."
    },
    {
      key: "premiseName",
      header: "Premise",
      headerTooltip:"Physical location where this meter is installed. Used for field navigation."
    },
    {
      key: "meterTypeDisplay",
      header: "Meter Type",
      headerTooltip:"Reading method: Smart (automated), Photo (image), or Manual (hand-entered). Affects field workflow."
    },
    {
      key: "status",
      header: "Status",
    headerTooltip:"Assignment status: Assigned (linked to route) or Unassigned (available for assignment)."
    },
      {
      key: "readingStatus",
      header: "Reading Status",
      sortable: true,
      headerTooltip:"Condition: Normal (working), Faulty (needs repair), RCNT (could not read). Plan maintenance accordingly."
    },
      {
      key: "categoryName",
      header: "Category",
      sortable: true,
      headerTooltip:"Condition: Normal (working), Faulty (needs repair), RCNT (could not read). Plan maintenance accordingly."
    },
      {
      key: "subCategoryName",
      header: "Sub Category",
      sortable: true,
      headerTooltip:"Condition: Normal (working), Faulty (needs repair), RCNT (could not read). Plan maintenance accordingly."
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <Card className="shadow-sm">
  <div className="space-y-6">          
 <GenericTable
          data={metersData}
          columns={columns}
          rowKey="id"
          loading={isLoading}
          pagination={{
            currentPage,
            totalPages: Math.ceil(totalCount / MODAL_PAGE_SIZE),
            totalItems: totalCount,
            itemsPerPage: MODAL_PAGE_SIZE,
            startItem: (currentPage - 1) * MODAL_PAGE_SIZE + 1,
            endItem: Math.min(currentPage * MODAL_PAGE_SIZE, totalCount)
          }}
          onPageChange={handlePageChange}
          searchPlaceholder="Search meters..."
          emptyMessage="No meters found"
        />
  </div>
  </Card>);
};